var DEFAULT_COUNTRY_CODE = window.iq.DEFAULT_COUNTRY_CODE || 'us';

module.exports = {
	setup_input: function (inputSelector, valueSelector) {
		var $input = window.jQuery(inputSelector);
		const _input = document.querySelector(inputSelector);
		if (!_input) {
			console.log(`Phone input ${inputSelector} was not found. \\n Phone number select will not work`);
		}
		window.intlTelInput(_input, {
			initialCountry: DEFAULT_COUNTRY_CODE,
			utilsScript: '/admin/assets/js/libs/intlTelInput-utils.js'
		});

		$input.on('blur', function (e) {
			if (e.target.value.trim() === '') {
				window.jQuery(valueSelector).val('');
				return;
			}
			var phone = cleanPhoneNumber(inputSelector);
			if (phone.isValid) {
				window.jQuery(valueSelector).val(phone.e164);
			}
		});
		_input.addEventListener('countrychange', () => {
			var phone = cleanPhoneNumber(inputSelector);
			if (phone.isValid) {
				window.jQuery(valueSelector).val(phone.e164);
			}
		});
	}
};

function cleanPhoneNumber(selector) {
	var iti = window.intlTelInputGlobals?.getInstance(document.querySelector(selector));

	if (iti && iti.isValidNumber()) {
		var intlData = iti.getSelectedCountryData();
		var userEnteredValueAsE164 = iti.getNumber();
		var countryCode = intlData.iso2;
		var dialCode = intlData.dialCode;

		var dialCodeLen = typeof dialCode === 'undefined' ? 0 : dialCode.toString().length;
		var firstN = userEnteredValueAsE164.substring(0, dialCodeLen + 1);
		var cleanedNumber = userEnteredValueAsE164;
		var lenWithoutDialCode = userEnteredValueAsE164.length - dialCodeLen - 1;

		//make sure dial code only appears once in the final number
		if (firstN === '+' + dialCode) {
			cleanedNumber = userEnteredValueAsE164.slice(-1 * lenWithoutDialCode);
		}

		return {
			isValid: true,
			dialCode: dialCode,
			countryCode: countryCode,
			number: cleanedNumber,
			e164: userEnteredValueAsE164
		};
	} else {
		return {
			isValid: false,
			dialCode: '',
			countryCode: '',
			number: '',
			e164: ''
		};
	}
}
